import { FormField, TextInput } from "@a2z/ui";
import { useTranslate } from "@/lib/i18n";
import type { SettlementMethod } from "@/lib/api/types";
import {
  TENDER_REFERENCE_MAX,
  sanitizeTypedTenderReference,
  takesTenderReference,
} from "@/modules/pos/lib/tenderReference";

/**
 * «مرجع العملية» — D163 (F39, founder 2026-10-15: "(b) Optional ref").
 *
 * One optional text field on every settle window (the light till's
 * `PaperSettleSheet`, the dark till's `SettleSheet` and `PartialSettleSheet`),
 * shown ONLY while CARD or INSTAPAY is the chosen method — a cash tender has
 * no transaction to point at. Never required and never a reason Pay is
 * refused: an empty field sends nothing. 32 characters, the server's ceiling.
 *
 * LTR, like the platform's order number beside it on the open dialog: an
 * approval code is read back digit by digit, in the order it was typed.
 */
export function TenderReferenceField({
  method,
  value,
  onChange,
  disabled,
  testId,
}: {
  method: SettlementMethod;
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  testId: string;
}) {
  const t = useTranslate();
  if (!takesTenderReference(method)) return null;
  return (
    <FormField
      name="tenderReference"
      label={t((m) => m.pos.tenderReferenceLabel)}
      helperText={t((m) => m.pos.tenderReferenceHint)}
    >
      <TextInput
        name="tenderReference"
        value={value}
        maxLength={TENDER_REFERENCE_MAX}
        dir="ltr"
        autoComplete="off"
        autoCapitalize="characters"
        disabled={disabled}
        // A `|` or a control character is dropped as typed: the server
        // refuses both, and this field never blocks Pay (6.5 gate R3).
        onChange={(event) =>
          onChange(sanitizeTypedTenderReference(event.target.value))
        }
        data-testid={testId}
      />
    </FormField>
  );
}
